import template from './errorList.html';
import controller from './errorList.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    errors: '<',
  },
};

export default component;
